import React, { useState, useEffect } from "react"
import { Box, Container } from "@mui/material"
import makeStyles from "@mui/styles/makeStyles"
import ChangePassword from "../components/ChangePassword"

const useStyles = makeStyles((theme) => {
    return {
        container: {
            height: "100vh",
            display: "flex!important",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflowY: "auto", // permite scroll vertical
            padding: 0,
            margin: 0,
        },
    }
})

export default function TechnicianFirstLogin(props) {
    const classes = useStyles()

    return (
        <Container 
            className={classes.container}
            maxWidth={false}
            disableGutters
        >
            <ChangePassword 
                technician={true} 
                populateData={props.populateData} 
                data={props} 
            />
        </Container>
    )
}